<template>
    <tr>
        <slot />
    </tr>
</template>

<script lang="ts">
export default {
    provide() {
        return {
            isStickyTop: () => this.isSticky,
            isSubHeader: () => this.isSubHeader,
            /*
                In Chrome <thead> nor <tr> can have `position: sticky` applied to
                them, so we need to apply it to the <th> elements, so we calculate
                the offset once and pass it down to all children.
            */
            stickyTopOffsetPixels: () => this.stickyOffsetPixels
        };
    },
    props: {
        isSticky: {
            type: Boolean
        },
        isSubHeader: {
            type: Boolean
        }
    },
    data() {
        return {
            stickyOffsetPixels: undefined as number | undefined
        };
    },
    mounted() {
        if (this.isSticky) {
            this.setStickyOffsetPixels();
        }
    },
    methods: {
        setStickyOffsetPixels() {
            this.stickyOffsetPixels = (this.$el as HTMLElement).offsetTop;
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
